import { render, staticRenderFns } from "./PatientNew.vue?vue&type=template&id=5807e696&scoped=true&"
import script from "./PatientNew.vue?vue&type=script&lang=js&"
export * from "./PatientNew.vue?vue&type=script&lang=js&"
import style0 from "./PatientNew.vue?vue&type=style&index=0&id=5807e696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807e696",
  null
  
)

export default component.exports